import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ChatContext = createContext(null);

const defaultActiveContext = {
  view: 'dashboard',
  client_id: null,
  project_id: null
};

export const ChatContextProvider = ({ children }) => {
  const [activeContext, setActiveContextState] = useState(defaultActiveContext);
  const [authContext, setAuthContextState] = useState({ teamId: null, userId: null });

  const setActiveContext = useCallback((next) => {
    setActiveContextState(prev => ({
      ...prev,
      ...(next || {})
    }));
  }, []);

  const resetActiveContext = useCallback(() => {
    setActiveContextState(defaultActiveContext);
  }, []);

  const setAuthContext = useCallback((next) => {
    setAuthContextState(prev => ({
      ...prev,
      ...(next || {})
    }));
  }, []);

  const value = useMemo(() => ({
    activeContext,
    setActiveContext,
    resetActiveContext,
    authContext,
    setAuthContext
  }), [activeContext, setActiveContext, resetActiveContext, authContext, setAuthContext]);

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => {
  const ctx = useContext(ChatContext);
  if (!ctx) {
    throw new Error('useChatContext must be used within ChatContextProvider');
  }
  return ctx;
};

export default ChatContext;
